// libraries/photos/src/routes/photoRouteIds.ts
export enum PhotoRouteId {
  PhotosRoot = 'photosRoot',
  PhotosAlbum = 'photosAlbum',
  PhotosAlbumList = 'photosAlbumList',
  PhotosAlbumsNormal = 'photosAlbumsNormal',
  PhotosAlbumsShared = 'photosAlbumsShared',
  PhotosAlbumsLocation = 'photosAlbumsLocation',
  PhotosAllShared = 'photosAllShared',
  PhotosAllHidden = 'photosAllHidden',
  PhotosHiddenMedia = 'photosHiddenMedia',
  PhotosTimeline = 'photosTimeline',
  PhotosMedia = 'photosMedia',
  PhotosAlbumInfoLoader = 'photosAlbumInfoLoader',
  PhotosPublicAlbumInfoLoader = 'photosPublicAlbumInfoLoader',
  PhotosShare = 'photosShare',
  PhotosShareMediaId = 'photosShareMediaId',
  PhotosShareActionAddPhotos = 'photosShareActionAddPhotos',
  PhotosShareActionFollowAlbum = 'photosShareActionFollowAlbum',
}
